import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'distinctBy'
})
export class DistinctByPipe implements PipeTransform {

  transform(value: any[], key: string): any[] {
    if (!Array.isArray(value) || !key) {
      return value;
    }

    const uniqueItems = value.filter((item, index, self) =>
      index === self.findIndex((t) => (
        t[key] === item[key]
      ))
    );

    return uniqueItems;
  }
}
